// extracted by mini-css-extract-plugin
export default {"wrapper":"MasterPlan_wrapper__HJWZH"};